import { render } from "./BoundariesComponent.vue?vue&type=template&id=46ab2767"
import script from "./BoundariesComponent.vue?vue&type=script&lang=js"
export * from "./BoundariesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__